import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export default withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "help-center-topics" */ './hocs')),
});
